import { render, staticRenderFns } from "./ModuleReworkDialog.vue?vue&type=template&id=33948eb4"
import script from "./ModuleReworkDialog.vue?vue&type=script&lang=js"
export * from "./ModuleReworkDialog.vue?vue&type=script&lang=js"
import style0 from "./ModuleReworkDialog.vue?vue&type=style&index=0&id=33948eb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports